import React, { useState } from "react";
import certifications from "../data/certifications.json";
import "../styles/Certifications.css";

function issuerInitials(issuer) {
  const words = issuer.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "DB";
  return words.length === 1
    ? words[0].slice(0, 2).toUpperCase()
    : words.slice(0, 2).map(word => word[0]).join("").toUpperCase();
}

function CertificationBadge({ certification }) {
  const [imageFailed, setImageFailed] = useState(false);
  const badge = imageFailed ? (
    <span className="certification-badge-fallback" aria-hidden="true">
      {issuerInitials(certification.issuer)}
    </span>
  ) : (
    <img
      className={`certification-badge-image${certification.badgeStyle ? ` certification-badge-${certification.badgeStyle}` : ""}`}
      src={certification.badgeImage}
      alt={certification.badgeAlt || `${certification.issuer || "Certification"} badge`}
      onError={() => setImageFailed(true)}
    />
  );

  if (certification.verifyUrl) {
    return (
      <a
        className="certification-badge-link"
        href={certification.verifyUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Verify ${certification.name}`}
      >
        {badge}
      </a>
    );
  }

  return <span className="certification-badge-link">{badge}</span>;
}

export default function Certifications() {
  return (
    <section id="certifications" className="site-section certifications-section">
      <div className="section-header">
        <h2 className="section-title">Certifications</h2>
      </div>

      <div className="certifications-grid">
        {certifications.map(certification => (
          <article className="certification-card" key={certification.id}>
            <CertificationBadge certification={certification} />
            <div className="certification-card-content">
              <h3 className="certification-name" title={certification.name}>{certification.name}</h3>
              {certification.issuer && (
                <p className="certification-issuer" title={certification.issuer}>
                  {certification.issuerUrl ? (
                    <a href={certification.issuerUrl} target="_blank" rel="noopener noreferrer">{certification.issuer}</a>
                  ) : certification.issuer}
                </p>
              )}
              {certification.date && <time className="certification-date">{certification.date}</time>}
              {certification.verifyUrl && (
                <a
                  className="certification-verify"
                  href={certification.verifyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Verify <span aria-hidden="true">→</span>
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
